
import { Shield, BookOpen, Sparkles } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const Mission = () => (
  <div className="max-w-5xl mx-auto px-6 py-24">
    <div className="text-center mb-16">
      <span className="text-sm uppercase tracking-widest text-accent font-medium">Our Mission</span>
      <h2 className="text-3xl md:text-4xl font-display font-medium mb-6 mt-2">
        Why We Started This Movement
      </h2>
      <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
        Financial institutions have held your data hostage for too long. We're creating a movement where your financial data works for you, empowering you with insights that transform your financial future.
      </p>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
      <Card className="bg-background border-border/40 hover:border-primary/40 transition-all">
        <CardContent className="p-6 space-y-4">
          <div className="h-12 w-12 rounded-lg bg-primary/10 text-primary flex items-center justify-center">
            <Shield className="h-6 w-6" />
          </div>
          <h3 className="text-xl font-medium">Your Data, Your Control</h3>
          <p className="text-muted-foreground">
            We believe your financial data belongs to you, not corporations that profit from it without your knowledge.
          </p>
        </CardContent>
      </Card>

      <Card className="bg-background border-border/40 hover:border-primary/40 transition-all">
        <CardContent className="p-6 space-y-4">
          <div className="h-12 w-12 rounded-lg bg-accent/10 text-accent flex items-center justify-center">
            <BookOpen className="h-6 w-6" />
          </div>
          <h3 className="text-xl font-medium">Financial Transparency</h3>
          <p className="text-muted-foreground">
            We're creating a new standard of transparency in an industry notorious for hiding behind complex jargon and fees.
          </p>
        </CardContent>
      </Card>

      <Card className="bg-background border-border/40 hover:border-primary/40 transition-all">
        <CardContent className="p-6 space-y-4">
          <div className="h-12 w-12 rounded-lg bg-primary/10 text-primary flex items-center justify-center">
            <Sparkles className="h-6 w-6" />
          </div>
          <h3 className="text-xl font-medium">Empowerment Through Clarity</h3>
          <p className="text-muted-foreground">
            When you understand your financial data, you gain the power to transform your financial future on your own terms.
          </p>
        </CardContent>
      </Card>
    </div>
  </div>
);

export default Mission;
